import { Stack } from "@mui/material";
import { FormDialog, FormikTextField } from "@shared";

import { AppointmentExchangeResponse } from "@/api";
import { RequestedPurposesField } from "@/pages/exchange/components/requested-purposes-field/RequestedPurposesField";
import { useTranslation } from "@/translations";

import { useEditExchangeRequest } from "./hooks/useEditExchangeRequest";

interface Props {
  exchange: AppointmentExchangeResponse;
  onClose: () => void;
}

export function EditExchangeRequestDialog({ exchange, onClose }: Props) {
  const { t } = useTranslation();
  const { formik, submitDisabled } = useEditExchangeRequest({ exchange, onClose });

  return (
    <FormDialog
      title={t("exchange.editRequestDialog.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.save")}
      submitDisabled={submitDisabled}
      fullWidth
    >
      <Stack spacing={3}>
        <RequestedPurposesField formik={formik} />

        <FormikTextField
          formik={formik}
          fieldName="note"
          label={t("exchange.requestedServices.note")}
          multiline
          rows={3}
          placeholder={t("exchange.requestedServices.notePlaceholder")}
        />
      </Stack>
    </FormDialog>
  );
}
